function fixedHeaderInit() {
	var siteHeader = document.querySelector("[data-fixed-header]");
	const siteHeaderFixedClass = "site-header-is-fixed";
	const siteHeaderFixedMinimumWidth = 1024;

	if (siteHeader) {
		if (window.innerWidth >= siteHeaderFixedMinimumWidth) {
			var siteHeaderHeight = siteHeader.offsetHeight + siteHeader.offsetTop;
			document.body.style.setProperty(
				"--siteHeaderHeight",
				siteHeaderHeight + "px"
			);
			headerFixedDecision(siteHeaderHeight);
		}
		return;

		function headerFixedDecision(fixedStartPosition) {
			$(window).scroll(function() {
				if (window.innerWidth >= siteHeaderFixedMinimumWidth) {
					var scrollPosition = window.pageYOffset;
					if (scrollPosition >= fixedStartPosition) {
						if (!document.body.classList.contains(siteHeaderFixedClass)) {
							document.body.classList.add(siteHeaderFixedClass);
						}
					} else {
						document.body.classList.remove(siteHeaderFixedClass);
					}
				}
			});
		}
	}
}